/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
export var acceptLanguage = {
    parameterPath: [
        "options",
        "acceptLanguage"
    ],
    mapper: {
        serializedName: "Accept-Language",
        type: {
            name: "String"
        }
    }
};
export var apiVersion = {
    parameterPath: "apiVersion",
    mapper: {
        required: true,
        serializedName: "api-version",
        defaultValue: '3.0',
        type: {
            name: "String"
        }
    }
};
export var category = {
    parameterPath: [
        "options",
        "category"
    ],
    mapper: {
        serializedName: "category",
        type: {
            name: "String"
        }
    }
};
export var endpoint = {
    parameterPath: "endpoint",
    mapper: {
        required: true,
        serializedName: "Endpoint",
        defaultValue: '',
        type: {
            name: "String"
        }
    },
    skipEncoding: true
};
export var from0 = {
    parameterPath: "from",
    mapper: {
        required: true,
        serializedName: "from",
        type: {
            name: "String"
        }
    }
};
export var from1 = {
    parameterPath: [
        "options",
        "from"
    ],
    mapper: {
        serializedName: "from",
        type: {
            name: "String"
        }
    }
};
export var fromScript0 = {
    parameterPath: [
        "options",
        "fromScript"
    ],
    mapper: {
        serializedName: "fromScript",
        type: {
            name: "String"
        }
    }
};
export var fromScript1 = {
    parameterPath: "fromScript",
    mapper: {
        required: true,
        serializedName: "fromScript",
        type: {
            name: "String"
        }
    }
};
export var includeAlignment = {
    parameterPath: [
        "options",
        "includeAlignment"
    ],
    mapper: {
        serializedName: "includeAlignment",
        type: {
            name: "Boolean"
        }
    }
};
export var includeSentenceLength = {
    parameterPath: [
        "options",
        "includeSentenceLength"
    ],
    mapper: {
        serializedName: "includeSentenceLength",
        type: {
            name: "Boolean"
        }
    }
};
export var language0 = {
    parameterPath: [
        "options",
        "language"
    ],
    mapper: {
        serializedName: "Language",
        type: {
            name: "String"
        }
    }
};
export var language1 = {
    parameterPath: "language",
    mapper: {
        required: true,
        serializedName: "language",
        type: {
            name: "String"
        }
    }
};
export var profanityAction = {
    parameterPath: [
        "options",
        "profanityAction"
    ],
    mapper: {
        serializedName: "profanityAction",
        type: {
            name: "String"
        }
    }
};
export var profanityMarker = {
    parameterPath: [
        "options",
        "profanityMarker"
    ],
    mapper: {
        serializedName: "profanityMarker",
        type: {
            name: "String"
        }
    }
};
export var scope = {
    parameterPath: [
        "options",
        "scope"
    ],
    mapper: {
        serializedName: "scope",
        constraints: {
            MaxItems: 3,
            MinItems: 0
        },
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Csv
};
export var script = {
    parameterPath: [
        "options",
        "script"
    ],
    mapper: {
        serializedName: "Script",
        type: {
            name: "String"
        }
    }
};
export var suggestedFrom = {
    parameterPath: [
        "options",
        "suggestedFrom"
    ],
    mapper: {
        serializedName: "suggestedFrom",
        type: {
            name: "String"
        }
    }
};
export var textType = {
    parameterPath: [
        "options",
        "textType"
    ],
    mapper: {
        serializedName: "textType",
        type: {
            name: "String"
        }
    }
};
export var to0 = {
    parameterPath: "to",
    mapper: {
        required: true,
        serializedName: "to",
        type: {
            name: "String"
        }
    }
};
export var to1 = {
    parameterPath: "to",
    mapper: {
        required: true,
        serializedName: "to",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Csv
};
export var toScript0 = {
    parameterPath: [
        "options",
        "toScript"
    ],
    mapper: {
        serializedName: "toScript",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Csv
};
export var toScript1 = {
    parameterPath: "toScript",
    mapper: {
        required: true,
        serializedName: "toScript",
        type: {
            name: "String"
        }
    }
};
export var xClientTraceId = {
    parameterPath: [
        "options",
        "xClientTraceId"
    ],
    mapper: {
        serializedName: "X-ClientTraceId",
        type: {
            name: "String"
        }
    }
};
//# sourceMappingURL=parameters.js.map